import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {USERS_LIST, USERS_NEW, USERS_EDIT, USERS_DELETE, USERS_BLOCK} from "./actionTypes"
import {usersListSuccess, usersListError, usersNewSuccess, usersNewError, usersDeleteSuccess, usersDeleteError, usersBlockSuccess, usersBlockError} from "./actions"

import {
  apiGetUsersList,
  apiPostUsersNew,
  apiPatchUsersEdit,
  apiDeleteUsersDelete,
  apiGetUsersBlock,
} from "../../api/calls/users"

function* usersList({payload: data}) {
  try {
    const response = yield call(apiGetUsersList, data)
    yield put(usersListSuccess(response))
  } catch (error) {
    yield put(usersListError(error))
  }
}

function* usersNew({payload: data}) {
  try {
    const response = yield call(apiPostUsersNew, data)
    yield put(usersNewSuccess(response))
  } catch (error) {
    yield put(usersNewError(error))
  }
}

function* usersEdit({payload: data}) {
  try {
    const response = yield call(apiPatchUsersEdit, data)
    yield put(usersNewSuccess(response))
  } catch (error) {
    yield put(usersNewError(error))
  }
}

function* usersDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteUsersDelete, data)
    yield put(usersDeleteSuccess(response))
  } catch (error) {
    yield put(usersDeleteError(error))
  }
}

function* usersBlock({payload: data}) {
  try {
    const response = yield call(apiGetUsersBlock, data)
    yield put(usersBlockSuccess(response))
  } catch (error) {
    yield put(usersBlockError(error))
  }
}

export function* watchUsersList() {
  yield takeEvery(USERS_LIST, usersList);
}

export function* watchUsersNew() {
  yield takeEvery(USERS_NEW, usersNew);
}

export function* watchUsersEdit() {
  yield takeEvery(USERS_EDIT, usersEdit);
}

export function* watchUsersDelete() {
  yield takeEvery(USERS_DELETE, usersDelete);
}

export function* watchUsersBlock() {
  yield takeEvery(USERS_BLOCK, usersBlock);
}

function* usersSaga() {
  yield all([
    fork(watchUsersList),
    fork(watchUsersNew),
    fork(watchUsersEdit),
    fork(watchUsersDelete),
    fork(watchUsersBlock),
  ]);
}

export default usersSaga
